var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "board-column",
      style: { backgroundColor: _vm.column.bgColor },
    },
    [
      _c("div", { staticClass: "column-header" }, [
        _c("span", { staticClass: "column-title" }, [
          _vm._v(_vm._s(_vm.column.title)),
        ]),
        _c("div", { staticClass: "column-header-right" }, [
          _c("span", { staticClass: "card-count" }, [
            _vm._v(_vm._s(_vm.activeCards.length)),
          ]),
        ]),
      ]),
      _c(
        "draggable",
        {
          staticClass: "card-list",
          attrs: {
            list: _vm.column.cards,
            group: "cards",
            "ghost-class": "ghost-card",
          },
          on: {
            change: function ($event) {
              return _vm.$emit("drag-change", $event, _vm.column.id)
            },
          },
        },
        _vm._l(_vm.column.cards, function (card) {
          return _c("card-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !card.archived,
                expression: "!card.archived",
              },
            ],
            key: card.id,
            attrs: { card: card, "member-options": _vm.memberOptions },
            on: {
              click: function ($event) {
                return _vm.$emit("card-click", card, _vm.column)
              },
              "toggle-check": function ($event) {
                return _vm.$emit("card-toggle-check", $event)
              },
              archive: function ($event) {
                return _vm.$emit("card-archive", $event)
              },
            },
          })
        }),
        1
      ),
      _c("div", { staticClass: "add-card-wrapper" }, [
        _vm.actionColumn.isAdding
          ? _c(
              "div",
              { staticClass: "add-card-form" },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 2,
                    placeholder: "輸入標題或黏貼連結",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.confirmAddCard($event)
                    },
                  },
                  model: {
                    value: _vm.actionColumn.newCardTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.actionColumn, "newCardTitle", $$v)
                    },
                    expression: "actionColumn.newCardTitle",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "add-card-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.confirmAddCard },
                      },
                      [_vm._v("添加卡片")]
                    ),
                    _c("i", {
                      staticClass: "el-icon-close cancel-btn",
                      on: { click: _vm.cancelAddCard },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "add-card-btn", on: { click: _vm.startAddCard } },
              [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" 添加卡片 ")]
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }